.#{$namespace}-message-box {
	width: 420px;
	max-width: calc(100vw - 32px);
	background: $white-color;
	border-radius: 4px;
	box-shadow: 0 0 4px alpha-color($black-color, 40%);
	padding: 16px;
	box-sizing: border-box;

	&.is-center {
		text-align: center;

		.#{$namespace}-message-box__btns {
			justify-content: center;

			// 有勾选时仍左右分，居中会把「不再提示」和按钮挤成一坨
			&.is-remember {
				justify-content: space-between;
			}
		}

		.#{$namespace}-message-box__content {
			justify-content: center;
		}
	}

	&__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 8px;
	}

	&__title {
		font-size: calc($font-size + 2px);
		font-weight: 600;
		color: $text-primary-color;
	}

	&__headerbtn {
		padding: 0;
		border: none;
		background: transparent;
		cursor: pointer;
		color: $text-placeholder-color;
		font-size: 16px;

		&:hover {
			color: color-token(primary);
		}
	}

	&__content {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		padding: 8px 0 12px;
		font-size: $font-size;
		color: $text-secondary-color;
		line-height: 1.5;
	}

	&__status {
		font-size: 22px;
		flex-shrink: 0;
		margin-top: 1px;

		&.is-success {
			color: color-token(success);
		}
		&.is-warning {
			color: color-token(warning);
		}
		&.is-info {
			color: color-token(info);
		}
		&.is-error {
			color: color-token(danger);
		}
	}

	&__input {
		margin-bottom: 8px;
	}

	&__errormsg {
		margin: 6px 0 0;
		font-size: 12px;
		color: color-token(danger);
		line-height: 1;
	}

	&__btns {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 12px;
		padding-top: 8px;

		// 情况1：底栏左侧勾选 — 文案和按钮拆开，避免跟确认抢主操作
		&.is-remember {
			justify-content: space-between;
		}
	}

	&__btns-actions {
		display: flex;
		flex-shrink: 0;
		gap: 12px;
	}
}
